import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  dateDivider: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: grey[500],
    "&::before, &::after": {
      content: "''",
      flex: 1,
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      margin: "0 16px",
    },
  },
  subName: {
    fontSize: "12px",
    color: grey[500],
  },
  conversationWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 0,
  },
  conversationContainer: {
    height: "100%",
    width: "100%",
    paddingTop: "40px",
    flexDirection: "column",
    padding: 0,
  },
  bubbleContainer: { flexGrow: 1, overflowY: "auto", minWidth: "375px" },
  scrollToBottomButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 50,
    position: "absolute",
    cursor: "pointer",
    zIndex: 1000,
    color: "white",
    opacity: 0.8,
    background: theme.palette.primary.main,
  },
}));
